const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Get stored token
export const getAccessToken = () => {
  return localStorage.getItem('access_token');
};

// Check if token is expired
export const isTokenExpired = () => {
  const expires = localStorage.getItem('token_expires');
  if (!expires) return true;
  return Date.now() > parseInt(expires);
};

// Check if user is authenticated
export const isAuthenticated = () => {
  const token = getAccessToken();
  if (!token) return false;
  return !isTokenExpired();
};

// Refresh token
export const refreshToken = async () => {
  const refresh_token = localStorage.getItem('refresh_token');
  if (!refresh_token) {
    throw new Error('No refresh token available');
  }

  try {
    const response = await fetch(`${API_BASE_URL}/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ refresh_token }),
    });

    if (!response.ok) {
      throw new Error('Token refresh failed');
    }

    const data = await response.json();
    
    // Update stored tokens
    localStorage.setItem('access_token', data.access_token);
    localStorage.setItem('refresh_token', data.refresh_token);
    localStorage.setItem('token_expires', Date.now() + (data.expires_in * 1000));
    
    return data.access_token;
  } catch (error) {
    // Clear stored tokens on refresh failure
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_expires');
    throw error;
  }
};

// Make authenticated API call
export const authenticatedFetch = async (endpoint, options = {}) => {
  let token = getAccessToken();
  
  // Check if token is expired and refresh if needed
  if (isTokenExpired() && token) {
    try {
      token = await refreshToken();
    } catch (error) {
      // Redirect to login or handle token refresh failure
      window.location.href = '/';
      return;
    }
  }

  // Prepare headers
  let headers = options.headers ? { ...options.headers } : {};

  // Only set Content-Type if not sending FormData
  const isFormData = options.body && typeof options.body === 'object' && options.body instanceof FormData;
  if (!isFormData && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL}${endpoint}`, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    // Token is invalid, clear storage and redirect
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token_expires');
    window.location.href = '/';
    return;
  }

  return response;
};

// Get user profile
export const getUserProfile = async () => {
  const response = await authenticatedFetch('/me');
  if (response.ok) {
    return await response.json();
  }
  return null;
}; 